import { store } from '../../store/create-store';
import { isPublicVisitorPath } from '../../app/premium-profile/profile-path';
import { hasRequestsInFlight, renewSessionAtTopLevel } from './api-v2.client';
import {
  hasOpenDialog,
  inPageRenewalWorks,
  isOnAuthCallback,
  tokenNeedsRenewal,
} from './session-renewal';

const CHECK_MS = 5 * 1000;
const IDLE_MS = 20 * 1000;
const ACTIVITY_EVENTS = [
  'pointerdown',
  'keydown',
  'touchstart',
  'wheel',
  'scroll',
];
const LISTENER_OPTIONS = { capture: true, passive: true };

let lastActivityAt = 0;
let timer: number | undefined;

const noteActivity = () => {
  lastActivityAt = Date.now();
};

const editingAField = () => {
  const element = document.activeElement as HTMLElement | null;
  if (!element) return false;
  return (
    element.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName)
  );
};

/** Where frames cannot renew, go to Keycloak at top level while the page is idle, before a tap meets an expired token. */
export function checkSession(now = Date.now()): void {
  if (document.hidden || inPageRenewalWorks()) return;
  const token = store.getState().common.auth?.token;
  if (!token || !tokenNeedsRenewal(token, now)) return;
  if (isOnAuthCallback() || isPublicVisitorPath(window.location.pathname)) {
    return;
  }
  if (
    now - lastActivityAt < IDLE_MS ||
    hasOpenDialog() ||
    editingAField() ||
    hasRequestsInFlight()
  ) {
    return;
  }
  renewSessionAtTopLevel('SessionKeeper');
}

const onVisibilityChange = () => {
  if (!document.hidden) noteActivity();
};

export function startSessionKeeper(): void {
  if (timer !== undefined) return;
  ACTIVITY_EVENTS.forEach(type =>
    window.addEventListener(type, noteActivity, LISTENER_OPTIONS),
  );
  document.addEventListener('visibilitychange', onVisibilityChange);
  timer = window.setInterval(() => checkSession(), CHECK_MS);
  checkSession();
}

export function stopSessionKeeper(): void {
  ACTIVITY_EVENTS.forEach(type =>
    window.removeEventListener(type, noteActivity, LISTENER_OPTIONS),
  );
  document.removeEventListener('visibilitychange', onVisibilityChange);
  window.clearInterval(timer);
  timer = undefined;
  lastActivityAt = 0;
}
